import { Button } from "@swiggy-private/dls-web-core/dist/components/Button";
import { TextButton } from "@swiggy-private/dls-web-core/dist/components/TextButton";
import styled from "styled-components";

interface IsMobileProps {
    isMobile?: boolean;
}

export const StyledTextButton = styled(TextButton)<IsMobileProps>(({ isMobile, theme }) => ({
    width: isMobile ? "104px" : "200px",
    margin: isMobile ? `0 ${theme.spacing.medium}` : "0",
    padding: 0,
    ...(!isMobile && {
        height: "58px",
    }),
}));

export const StyledButton = styled(Button)<IsMobileProps>(({ isMobile }) => ({
    width: isMobile ? "96px" : "200px",
    margin: "auto",
}));

export const Header = styled.div(({ theme }) => ({
    borderBottom: `1px solid ${theme.colors[theme.colorMode].border_Tertiary}`,
    whiteSpace: "nowrap",
    padding: `${theme.spacing.xLarge} ${theme.spacing.small} ${theme.spacing.small} ${theme.spacing.small}`,
}));

export const Container = styled.div(() => ({
    height: "70vh",
}));

export const ContentHeader = styled.div(({ theme }) => ({
    padding: `${theme.spacing.medium} 0`,
    textTransform: "uppercase",
}));

export const ContentFooter = styled.div(({ theme }) => ({
    display: "flex",
    "box-shadow": "0px -2.63677px 5.27354px rgba(40, 44, 63, 0.1)",
    width: "100%",
    bottom: 0,
    left: 0,
    position: "relative",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: `0 ${theme.spacing.medium}`,
    zIndex: 1,
    background: theme.colors[theme.colorMode].background_Primary,
    height: "calc(58px + var(--sab))",
    borderTop: `1px solid ${theme.colors[theme.colorMode].border_Tertiary}`,

    "@supports (padding-bottom: var(--sab))": {
        paddingBottom: "var(--sab)",
    },
}));

export const ToastContainer = styled.div(({ theme }) => ({
    width: "auto",
    margin: `0 ${theme.spacing.x6}`,
    display: "flex",
    gap: theme.spacing.x6,
    borderRadius: theme.cornerRadius.small,
    padding: `${theme.spacing.x6} ${theme.spacing.medium}`,
    alignItems: "center",
    justifyContent: "center",
    color: `${theme.colors[theme.colorMode].background_Primary}`,
    boxShadow: "0px 12px 28px rgba(27, 30, 36, 0.1)",
    background: `${theme.colors[theme.colorMode].background_inverse_Primary}`,
}));
